var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPayments = function SvgPayments(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H33V16.5H3V12Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 23.25C6.75 22.4216 7.42157 21.75 8.25 21.75H9.75C10.5784 21.75 11.25 22.4216 11.25 23.25C11.25 24.0784 10.5784 24.75 9.75 24.75H8.25C7.42157 24.75 6.75 24.0784 6.75 23.25Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 23.25C13.5 22.4216 14.1716 21.75 15 21.75H19.5C20.3284 21.75 21 22.4216 21 23.25C21 24.0784 20.3284 24.75 19.5 24.75H15C14.1716 24.75 13.5 24.0784 13.5 23.25Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.75C1.5 7.67893 3.17893 6 5.25 6H30.75C32.8211 6 34.5 7.67893 34.5 9.75V26.25C34.5 28.3211 32.8211 30 30.75 30H5.25C3.17893 30 1.5 28.3211 1.5 26.25V9.75ZM5.25 9C4.83579 9 4.5 9.33579 4.5 9.75V26.25C4.5 26.6642 4.83579 27 5.25 27H30.75C31.1642 27 31.5 26.6642 31.5 26.25V9.75C31.5 9.33579 31.1642 9 30.75 9H5.25Z",
    fill: "#7EAAFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payments.4e670463.svg";
export { ForwardRef as ReactComponent };